module.exports = __webpack_public_path__ + "img/rektor1.8e21f15f.jpg";